import * as React from 'react';
import AcceptInviteContainer from '../../containers/Auth/AcceptInvite';

const AcceptInvitePage = () => <AcceptInviteContainer />;

export default AcceptInvitePage;
